const events = [
  {
    eventYear: {
      year: '2019',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'dec',
          title: 'BTRE (Python Django)',
          url: 'http://52.28.62.150'
        },
        {
          month: 'aug',
          title: 'RPA Developer at EY',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'jun',
          title: 'Startup NDB Project on Java (Spring)',
          url: 'https://github.com/fykss/ndb'
        },
        {
          month: 'may',
          title: "Master's Degree, Institute of High Technologies, KNU",
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'may',
          title: 'Google Keep on NodeJS',
          url: 'https://github.com/fykss/node-todo'
        },
        {
          month: 'apr',
          title: 'Create React App (to do list)',
          url: 'https://fykss.github.io/react-app'
        },
        {
          month: 'mar',
          title: 'Tinder Web Application, team work',
          url: 'https://github.com/fykss/java-tinder'
        },
        {
          month: 'feb',
          title: 'Console Java application for booking air tickets',
          url: 'https://gitlab.com/NazDen/javacorestepproject'
        },
        {
          month: 'jan',
          title: 'Programming Teacher. Self-employment',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2018',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'nov',
          title: 'Teamwork, Forkio Project',
          url: 'https://fykss.github.io/forkio'
        },
        {
          month: 'oct',
          title: 'Frontend Developer at TG Production',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'sep',
          title: 'Web Project (The Ham)',
          url: 'https://fykss.github.io/the-ham'
        },
        {
          month: 'jul',
          title: 'Course Full Stack Developer DAN.IT education',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2017',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'sep',
          title:
            'Trip to my mother in Greece, a long-awaited meeting 7 years later...',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'jul',
          title: 'Bachelor of Science, Physics',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2015',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'jun',
          title: '3D Artist Architectural Visualization. Freelance',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2014',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'nov',
          title: 'The dream of a startup game. Developer + 3D Artist',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2013',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'sep',
          title: 'Hello, adult life. Relocate to Kiev, Ukraine',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'aug',
          title:
            "I'm a young physicist, entering to the T. Shevchenko National University of Kyiv",
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'apr',
          title: "Second place in the city's football championship",
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'feb',
          title: 'Winner city competitions GZR',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2012',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'sep',
          title: 'Immersion in education, training for ZNO',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2007',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'sep',
          title: 'Visit to the first math olympiad',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'jun',
          title:
            'Yard football, the dream of becoming a professional football player',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'mar',
          title: 'First computer. Counter strike 1.6, NFS, Generals',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '2002',
      content: [
        {
          month: '',
          title: '',
          url: ''
        },
        {
          month: 'aug',
          title: 'Relocate to Lugansk, Ukraine and went to the school',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  },
  {
    eventYear: {
      year: '1995',
      content: [
        {
          month: '',
          title: '',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        },
        {
          month: 'mar',
          title: 'Hello, World! I was born in Sovetsk, Russia',
          // eslint-disable-next-line no-script-url
          url: 'javascript: void(0)'
        }
      ]
    }
  }
];

export default events;
